import { useCallback } from "react";
import CommonValidatorProps from "./commonProps";
import useValidator from "./useValidator";
import { useTranslation } from "react-i18next";

export interface TextValidatorprops extends CommonValidatorProps<string> {
  required?: boolean;
  minLength?: number;
  maxLength?: number;
  regexPattern?: RegExp;
}

const useTextValidator = (props: TextValidatorprops) => {
  const { t } = useTranslation();
  const { required, minLength, maxLength, regexPattern, validationFunction } = props;

  const validateRequired = useCallback(
    (value?: string): [boolean, string] => {
      return [required ? value !== undefined && value.length > 0 : true, t("field:helper.fieldIsRequired")];
    },
    [required]
  );

  const validateMinLength = useCallback(
    (value?: string): [boolean, string] => {
      return [
        minLength ? value !== undefined && value.length >= minLength : true,
        `Min characters allowed : ${minLength}`,
      ];
    },
    [minLength]
  );

  const validateMaxLength = useCallback(
    (value?: string): [boolean, string] => {
      return [
        maxLength ? value !== undefined && value.length <= maxLength : true,
        `Max characters allowed : ${maxLength}`,
      ];
    },
    [maxLength]
  );

  const validateFunction = useCallback(
    (value?: string): [boolean, string] => {
      return [
        validationFunction && value !== undefined && value.length > 0 ? validationFunction(value) : true,
        "Field doesn't match Requierements",
      ];
    },
    [validationFunction]
  );

  const validateRegex = useCallback(
    (value?: string): [boolean, string] => {
      return [
        regexPattern ? value !== undefined && value.match(regexPattern) !== null : true,
        "Field doesn't match pattern",
      ];
    },
    [regexPattern]
  );

  const validator = useValidator({
    ...props,
    validators: [validateRequired, validateMinLength, validateMaxLength, validateRegex, validateFunction],
  });

  return validator;
};

export default useTextValidator;
